export default __webpack_public_path__ + "static/media/PressBrakeImg.66b797da.jpg";